import selectedProductsList from './selectedProductsList';

export default {
  template: '#details_tab',
  components: {
    selectedProductsList,
  },
  props: ['categories'],
  events: {
    'pricing-recalculated': function() {
      this.reCalculatePricing();
    },
    'on-product-select': function(selectedProduct, categories, forceSelection) {
      this.onProductSelected(selectedProduct, categories, forceSelection);
    },
    'design-ready': function() {
      this.mainProductDesign = this.getMainProductDesign();
      this.lastSelectedColor = this.$root.campaignData.mainProduct.currentColor.hex;
    },
    'on-dtg-enabled': function(state) {
      this.dtgEnabled = state;
    },
    'color-changed': function() {
      this.getMainProductColors();
    },
    'on-details-tab-back-clicked': function() {
      this.gotoDesigner();
    },
    'on-details-tab-next-clicked': function() {
      this.gotoLaunchCampaign();
    },
    'draft-loaded': function(campaignData) {
      this.importDraft(campaignData);
    },
    'on-preview-rendering': function() {
      this.onPreviewRendering();
    },
    'post-force-preview-campaign': function() {
      this.showLoading = false;
    },
    'on-additional-products-clear': function() {
      this.clearAdditionalProducts();
    },
    'user-initialized': function() {
      this.parseSellingPrice(null, true);
    },
  },
  watch: {
    sellingPrice: function(val) {
      this.$root.$set('campaignData.pricing.sellingPrice', val);
      this.updateAdditionalProductPricing(this.selectedProduct.product.id, this.sellingPrice, (parseFloat(this.sellingPrice) - parseFloat(this.basePrice)).toFixed(2));
      this.setProductForProfitEstimation(this.selectedProduct.product.id);

      this.$dispatch('selling_price_updated');
    }
  },
  ready: function() {
    if (this.isAPIOrder() === false || this.isManualOrder() === false) {
      this.setupTableSlider();
    }
    var self = this;
    $('.additional_products_list_scroll').mCustomScrollbar({ setHeight: '700px', theme: 'dark-thick' });

    $('#additional_product_modal').on('shown.bs.modal', function() {
      self.showCategories();
      $('.additional_products_list_scroll').mCustomScrollbar('update');
    });
  },
  data: function() {
    return {
      selectedProduct: false,
      selectedProducts: [],
      currentGoal: 50,
      //Defaults
      basePrice: 14,
      sellingPrice: 21.99,
      dtgPrice: 14,
      //--------
      mainProductColors: [],
      mainProductName: '',
      productList: [],
      imagePath: this.$root.getDesignerHelper().imagePath,
      toBoundProducts: [],
      dtgEnabled: true,
      screenColumn: 'col-md-6',
      mainProductColor: '',
      hoverColor: undefined,
      lastSelectedColor: undefined,
      activeCategory: false,
      mainProductDesign: '',
      uniqueCategories: [],
      showLoading: false,
      campaignCategories: [],
      additional_products: {
        current_view: 'CATEGORY',
        modal_title: 'CHOOSE A PRODUCT CATEGORY'
      },
      selectedProductForEstimation: null,
      sliderCount: 50,
      selectedProductItemForEstimation: "",
      estimatedProfitClass: 'text-success',
      distinctProductsOnCampaign: [],
      totalAllowedVariants: 50,
      totalColorVariantsByProduct: 10,
      enableAdditionalProductsButton: false
    };
  },
  methods: {
    onProductSelected(selectedProduct, categories, forceSelection) {
      this.selectedProduct = selectedProduct;
      this.mainProductName = this.getProductName(selectedProduct.product);
      //Default
      this.sellingPrice = selectedProduct.product.suggested_price ? parseFloat(selectedProduct.product.suggested_price).toFixed(2) : 21.99;
      this.getMainProductColors();
      this.setupAdditionalProducts(selectedProduct, categories, forceSelection);
      this.reCalculatePricing();
      this.enableAdditionalProductsButton = !selectedProduct.product.us_only;
    },
    clearAdditionalProducts() {
      this.$parent.selectedProducts = [];

      //Clearing the Additional Products if the main product is changed
      this.$root.campaignData.additionalProducts = [];
    },
    getProductName: function(product) {
      return product.name;
    },
    onPreviewRendering: function() {
      this.showLoading = true;
    },
    setActiveCategory: function(category) {
      this.activeCategory = category;
      this.additional_products.modal_title = 'CHOOSE A PRODUCT';
      this.additional_products.current_view = 'PRODUCT';
    },
    importDraft: function(campaignData) {
      var that = this,
        isSublimationProduct = that.$root.isSublimationProduct();

      this.$root.campaignData.pricing = campaignData.pricing;
      this.mainProductName = campaignData.mainProduct.product.product.name;
      this.sellingPrice = campaignData.pricing.sellingPrice;
      this.basePrice = campaignData.pricing.basePrice;

      var additionalProducts = campaignData.additionalProducts;
      var selectedProducts = _.groupBy(additionalProducts, function(item) {
        return item.product;
      });

      var productIds = _.keys(selectedProducts);
      _.each(productIds, function(id) {
        var firstProduct = selectedProducts[id][0];
        that.addProductById(id, firstProduct.selling_price, firstProduct.profit);
      });
    },
    getDesignCSS: function() {
      if (this.$root.campaignData.mainProduct.product.product) {
        var selectedProduct = this.$root.campaignData.mainProduct.product.product,
          mainProductHeight = selectedProduct[`${this.$root.currentSide}_image_height`],
          designContainerHeight = selectedProduct[`${this.$root.currentSide}_height`],
          mainProductTop = selectedProduct[`${this.$root.currentSide}_top`],
          mainProductLeft = selectedProduct[`${this.$root.currentSide}_left`],
          calculatedHeightRatio = parseFloat(mainProductHeight) / 200;

        return {
          top: mainProductTop / calculatedHeightRatio + 'px',
          left: mainProductLeft / calculatedHeightRatio + 'px',
          position: 'absolute',
          height: designContainerHeight / calculatedHeightRatio + 'px'
        };
      } else {
        return {
          top: '0px',
          left: '0px',
          position: 'absolute',
          height: '0px'
        }
      }
    },
    setupSlider: function() {
      var that = this;
      $('#tipping_point_slider').slider({
        min: 10,
        max: 210,
        range: 'min',
        value: this.$root.campaignData.goal,
        dataValue: [10, 25, 50, 75, 100, 125, 150, 175, 200, 250, 300]
      }).slider("pips", {
        rest: "label",
        step: 20
      }).slider("float").on("slidechange", function(e, ui) {
        that.$root.$set('campaignData.goal', ui.value);
        that.currentGoal = ui.value;
      });
    },
    setupTableSlider: function() {
      const PRICE_ROW_OFFSET_TOP = 38;
      const SLIDER_OFFSET_HEIGHT = 178;
      const PRICE_ROW_OFFSET_HEIGHT = 175;
      const PRICE_ROW_TOP_MULTIPLIER = PRICE_ROW_OFFSET_HEIGHT / SLIDER_OFFSET_HEIGHT;

      let $priceRow = $('.price-slider-row-container'),
        $sliderHandle;

      // defer jquery select of slide handle since it does not exist yet
      _.defer(() => {
        $sliderHandle = $('.slider-handle');
      });

      let slider = new Slider("#vertical_price_slider", {
        value: 50,
        ticks: [1, 10, 25, 50, 100, 500],
        ticks_positions: [1, 20, 40, 60, 80, 100],
        ticks_snap_bounds: 1,
        orientation: 'vertical',
        tooltip: 'hide'
      }).on('change', (e) => {
        this.sliderCount = e.newValue;

        if (this.isDTGProduct && e.newValue < 10) {
          slider.setValue(10);
          this.sliderCount = 10;
        }

        let slideTop = (parseFloat($sliderHandle.css('top')) * PRICE_ROW_TOP_MULTIPLIER) + PRICE_ROW_OFFSET_TOP;
        $priceRow.css("top", `${slideTop}px`);
      });
    },
    gotoLaunchCampaign: function() {
      //Showing the 2nd Tab of the Wizard
      var colorValidation = this.validateColorsSelected();
      if (colorValidation.length > 0) {
        helpers.alert("No colors selected for " + colorValidation.join(", ") + ". Please select a color or delete the product.");
      } else if (this.validateSellingPrice().length > 0) {
        helpers.alert("All selling prices must be higher than base cost.");
      } else {
        var userObj = this.$root.service.user.object;
        if (userObj == null) {
          this.$dispatch('on-open-login');
        } else {
          $('#form_wizard_1').bootstrapWizard('show', 2);
          $.uniform.restore("input");
          $('#accept_terms').uniform();
          $('#auto_import').uniform();
        }
      }
    },
    validateColorsSelected: function() {
      var productsSelected = this.selectedProducts,
        selectedProductsWithNoColors = [],
        globalAdditionalProductSelections = this.$root.campaignData.additionalProducts;

      _.each(productsSelected, function(product) {
        var product_id = product.product.products.id;
        var colorsExist = _.filter(globalAdditionalProductSelections, function(globalProduct) {
          return globalProduct.product == product_id;
        });

        if (colorsExist.length == 0) {
          selectedProductsWithNoColors.push(product.product.products.name);
        }
      });

      return selectedProductsWithNoColors;
    },
    validateSellingPrice: function() {
      var invalidSellingPrice = [],
        globalAdditionalProductSelections = this.$root.campaignData.additionalProducts;

      if (this.isAPIOrder() === false && this.isManualOrder() === false) {
        if (+this.sellingPrice < +this.basePrice) {
          invalidSellingPrice.push('Main Product')
        }
        _.each(globalAdditionalProductSelections, function(additionalProduct) {
          if ((+additionalProduct.profit) < 0) {
            invalidSellingPrice.push('Additional Products');
          }
        });
      }

      return invalidSellingPrice;
    },
    gotoDesigner: function() {
      //Showing the 2nd Tab of the Wizard
      $('#form_wizard_1').bootstrapWizard('show', 0);
    },
    setHoverColor: function(color) {
      this.hoverColor = color.hex;
    },
    resetHoverColor: function() {
      this.hoverColor = undefined;
    },
    setLastColor: function(color) {
      //this.lastSelectedColor = color.hex;
    },
    getMainProductColors: function() {
      var that = this;
      if (this.selectedProduct) {
        var productColors = this.selectedProduct.product.product_colors,
          selectedColor = this.$root.currentColor,
          mainProductColors = [],
          currentSelectedColor = this.$root.currentColor,
          additionalProducts = this.$root.campaignData.additionalProducts;

        _.each(productColors, function(color) {
          if (color.hex == that.$root.currentColor.hex) {
            that.lastSelectedColor = color.hex;
          }
          mainProductColors.push(color);
        });

        var mainProductIndexFromAdditionalProducts = _.findIndex(additionalProducts, function(product) {
          return product.product == currentSelectedColor.product_id && product.color == currentSelectedColor.id;
        });

        if (mainProductIndexFromAdditionalProducts > -1) {
          additionalProducts.splice(mainProductIndexFromAdditionalProducts, 1);
        }

        this.mainProductColor = selectedColor;
        this.$set('mainProductColors', mainProductColors);
      } else {
        this.$set('mainProductColors', [])
      }
    },
    activateColor: function(color, product_id, selling_price, profit, base_price, dtg_price) {
      var designer_selected_color = this.$root.currentColor;
      if (color.hex != designer_selected_color.hex || product_id != null) {
        var that = this;
        var globalAdditionalProductSelections = this.$root.campaignData.additionalProducts;

        var productExists = _.findIndex(globalAdditionalProductSelections, function(p) {
          return (p.product == (product_id ? product_id : that.selectedProduct.product.id) && p.color == color.id);
        });

        if (productExists == -1) {
          if (this.isAPIOrder()) {
            var currentProductVariantsCount = this.$root.getVariantsByProduct(product_id).length;
            var sizeCountForTheProduct = this.$root.getSizesByProduct(product_id).length;
            if ((currentProductVariantsCount + sizeCountForTheProduct) >= 100) {
              helpers.alert('Shopify does not allow a product to have more than 100 variants.');
              return false;
            }
          }

          //Checking if the total color variants per product is less than or equal to 10
          if (this.checkColorCountVariationByProduct(product_id ? product_id : that.selectedProduct.product.id)) {
            helpers.alert('There is a restriction of up to 10 colors per Product');
            return false;
          }

          if (globalAdditionalProductSelections.length === (this.totalAllowedVariants - 1)) { //adding -1 as the main product is not part of the additional products array
            helpers.alert('Too many products selected, we only allow up to ' + this.totalAllowedVariants + ' combinations');
            return false;
          }

          globalAdditionalProductSelections.push({
            product: product_id ? product_id : that.selectedProduct.product.id,
            color: color.id,
            hex: color.hex,
            selling_price: selling_price ? selling_price : this.sellingPrice,
            profit: parseFloat(profit ? profit : this.profit).toFixed(2),
            base_price: base_price ? base_price : this.basePrice,
            dtg_price: dtg_price ? dtg_price : this.dtgPrice,
            dtg_profit: parseFloat(parseFloat(selling_price) - parseFloat(dtg_price)).toFixed(2)
          });
        } else {
          if (!product_id) {
            var productToBeRemoved = globalAdditionalProductSelections[productExists];
            if (productToBeRemoved.hex == color.hex) {
              this.lastSelectedColor = designer_selected_color.hex;
            }
          }
          globalAdditionalProductSelections.splice(productExists, 1);
        }
        this.setProductForProfitEstimation(product_id);
      }
    },
    checkColorCountVariationByProduct(productId) {
      var globalAdditionalProductSelections = this.$root.campaignData.additionalProducts,
        colorsByProduct = globalAdditionalProductSelections.filter(function(product) {
          return product.product === productId;
        }),
        countToCheck = this.selectedProduct.product.id === productId ? this.totalColorVariantsByProduct - 1 : this.totalColorVariantsByProduct;

      return (colorsByProduct.length === countToCheck);
    },
    isColorActive: function(color, product_id) {
      var that = this;
      var globalAdditionalProductSelections = this.$root.campaignData.additionalProducts;
      var productExists = _.findIndex(globalAdditionalProductSelections, function(p) {
        return (p.product == (product_id ? product_id : that.selectedProduct.product.id) && p.color == color.id);
      });

      return (productExists > -1);
    },
    setupAdditionalProducts: function(currentProduct, categories, forceSelection) {
      if (currentProduct.product.non_additional == "0") {
        //Plucking all the products from the categories
        var products = _.flatten(_.pluck(categories, 'category_products'));

        //Removing the Current selected product on the designer so that the rest can be added as additional products
        _.remove(products, function(product) {
          return product.product == currentProduct.product.id || product.products.non_additional == 1 || product.products.group_id != currentProduct.product.group_id;
        });

        var uniqueCategoriesId = _.uniq(_.pluck(products, 'category'));
        var uniqueCategories = [],
          that = this;

        _.each(uniqueCategoriesId, function(category) {
          uniqueCategories.push(that.getCategoryById(category, categories));
        });

        this.$set('uniqueCategories', uniqueCategories);

        //Saving the list of all the products so that they can be referred to when adding and deleting products
        this.$set('productList', products);

        //Variable that will store all the products that will be bound to the carousel
        this.$set('toBoundProducts', products);

        if (forceSelection) {
          //Clearing the Additional Products if the main product is changed
          this.$set('selectedProducts', []);
          this.$root.campaignData.additionalProducts = [];
        }

        // Adding all canvas products by default
        if (currentProduct.product.product_type === "CANVAS") {
          let self = this;
          let toBoundProductsCopy = this.toBoundProducts.slice();
          toBoundProductsCopy.forEach(function(product) {
            self.addProduct(null, product);
          });
        }
      } else {
        //Emptying the products List as this does not apply to products that doesn't support non-additional
        this.$set('productList', []);
        this.$set('toBoundProducts', []);

        if (forceSelection) {
          //Clearing the Additional Products if the main product is changed
          this.$set('selectedProducts', []);
          this.$root.campaignData.additionalProducts = [];
        }
      }
    },
    getCategoryById: function(categoryId, categories) {
      return _.find(categories, function(category) {
        return category.id == categoryId;
      });
    },
    addProductById: function(id, sellingPrice, profit) {
      var product = _.find(this.toBoundProducts, function(item) {
        return item.products.id == id;
      });

      if (product) {
        this.addProduct(null, product, sellingPrice, profit);
      }
    },
    addProduct: function(e, product, sellingPrice) {
      var currentProductIndex = _.findIndex(this.toBoundProducts, function(item) {
        return item.products.id == product.products.id;
      });
      if (currentProductIndex > -1) {
        var base_price = parseFloat(this.getPricingByProduct(product.products, this.campaignGoal)),
          selling_price = (this.isManualOrder()) ? base_price : (sellingPrice ? parseFloat(sellingPrice) : parseFloat(product.products.suggested_price)),
          dtg_price = parseFloat(this.getPricingByProduct(product.products, 1));

        var obj = {
          product: this.toBoundProducts[currentProductIndex],
          // TODO: Update to not be hard coded
          base_price: base_price ? base_price.toFixed(2) : 14.00,
          selling_price: selling_price ? selling_price.toFixed(2) : 24.99,
          dtg_price: dtg_price ? dtg_price.toFixed(2) : 18.00
        };
        this.selectedProducts.push(obj);
        this.toBoundProducts.splice(currentProductIndex, 1);
        $('.additional_products_list_scroll').mCustomScrollbar('update');
        $('[data-toggle="tooltip"]').tooltip({ html: true });

        //TODO: Show Categories only if the current category doesn't have any products
        //this.showCategories();
      }
    },
    removeItem: function(product) {
      var parentProductIndex = _.findIndex(this.selectedProducts, function(item) {
        return item.product.products.id == product.products.id;
      });

      var boundedItems = this.toBoundProducts;
      boundedItems.push(product);
      this.$set('toBoundProducts', boundedItems);

      this.selectedProducts.splice(parentProductIndex, 1);

      // var globalAdditionalProductSelections = this.$root.campaignData.additionalProducts;

      _.remove(this.$root.campaignData.additionalProducts, function(item) {
        return item.product == product.products.id;
      });
      $('.additional_products_list_scroll').mCustomScrollbar('update');
      this.setProductForProfitEstimation(this.$root.selectedProduct.product.id);
    },
    reCalculatePricing: function() {
      var sellingPrice = this.sellingPrice == 0 ? this.$root.campaignData.mainProduct.product.product.suggested_price : this.sellingPrice,
        mainProductObj = this.getProductById(this.$root.selectedProduct.product.id).products,
        dtgPrice = parseFloat(this.getPricingByProduct(mainProductObj, 1)),
        basePrice = parseFloat(this.getPricingByProduct(mainProductObj, this.campaignGoal));

      this.sellingPrice = parseFloat(sellingPrice).toFixed(2);
      this.basePrice = "";
      this.dtgPrice = dtgPrice.toFixed(2);
      this.setProductForProfitEstimation(this.$root.selectedProduct.product.id);
    },
    parseSellingPrice: function(e, skipNotification) {
      if (!this.$root.selectedProduct) return false;

      var sellingPrice = parseFloat(this.sellingPrice),
        mainProductObj = this.getProductById(this.$root.selectedProduct.product.id).products,
        dtgPrice = parseFloat(this.getPricingByProduct(mainProductObj, 1)),
          maxSellingPrice = 0;

      if(this.isDoubleSided()) {
        maxSellingPrice = parseFloat(this.$root.selectedProduct.product.max_selling_price_double_sided);
      } else {
        maxSellingPrice = parseFloat(this.$root.selectedProduct.product.max_selling_price);
      }

      if (isNaN(sellingPrice)) sellingPrice = 0.00;

      if (sellingPrice < dtgPrice) {
        this.$set('sellingPrice', dtgPrice.toFixed(2));
        if (!skipNotification) helpers.alert("The selling price of a product cannot be less than the Base cost of 1 product sold");
      } else {
        this.$set('sellingPrice', sellingPrice.toFixed(2));
      }

      // Only check for maximum selling price if it is not a Shopify Campaign
      if (this.isAPIOrder() === false) {
        if (maxSellingPrice !== 0.00 && sellingPrice > maxSellingPrice) {
          helpers.alert("The selling price for this product cannot exceed $" + maxSellingPrice.toFixed(2));
          this.$set('sellingPrice', maxSellingPrice.toFixed(2));
        }
      }

      this.$root.campaignData.pricing.sellingPrice = this.sellingPrice;
    },
    isDoubleSided: function() {
      return this.$root.designerItems.front.length > 0 && this.$root.designerItems.back.length > 0
    },
    isProfitLoss: function() {
      return parseFloat(this.profit) < 0;
    },
    isDTGLoss: function() {
      return parseFloat(this.dtgProfit) < 0;
    },
    isSublimationProduct: function() {
      return this.$root.isSublimationProduct();
    },
    getMainProductDesign: function() {
      if (this.isSublimationProduct()) {
        if (this.$root.designerItems[this.$root.currentSide].length > 0)
          return this.$root.designerItems[this.$root.currentSide][0].imageData['original_url'];
        else
          return '';
      } else {
        return this.$root.campaignData.design[this.$root.currentSide].upscaled;
      }
    },
    updateAdditionalProductPricing: function(productId, sellingPrice, profit) {
      var globalAdditionalProductSelections = this.$root.campaignData.additionalProducts;
      _.forEach(globalAdditionalProductSelections, function(item) {
        if (item.product == productId) {
          item.selling_price = sellingPrice;
          item.profit = profit;
        }
      });

      this.$dispatch('selling_price_updated');

      this.setProductForProfitEstimation(productId);
    },
    isManualOrder: function() {
      return this.$root.isManualOrder();
    },
    estimatedSalePrice: function(product) {
      if (this.$root.selectedProduct) {
        var highSalesCount = 300,
          lowSalesCount = 1,
          productObj = product == undefined ? this.$root.selectedProduct.product : product,
          highSalesBaseCost = this.getPricingByProduct(productObj, highSalesCount),
          lowSalesBaseCount = this.getPricingByProduct(productObj, lowSalesCount);

        if (this.isAPIOrder()) {
          return '$' + parseFloat(lowSalesBaseCount).toFixed(2);
        } else {
          return '$' + parseFloat(highSalesBaseCost).toFixed(2) + ' - ' + '$' + parseFloat(lowSalesBaseCount).toFixed(2);
        }
      }
    },
    isEmbroideryProduct: function() {
      return this.$root.isEmbroideryProduct();
    },
    sortProfits: function(profits, currentGoal) {
      var sortedProfits = _.sortBy(profits),
        endProfit = sortedProfits[sortedProfits.length - 1],
        startProfit = sortedProfits[0],
        computedEndProfit = parseFloat(endProfit),
        computedStartProfit = parseFloat(startProfit);

      return [computedStartProfit, computedEndProfit];
    },
    isAPIOrder: function() {
      return this.$root.isAPIOrder();
    },
    getCategoryIcon(category) {
      return category.icon_class;
    },
    onBackButtonClicked() {
      this.showCategories();
    },
    showCategories() {
      this.additional_products.modal_title = 'CHOOSE A PRODUCT CATEGORY';
      this.additional_products.current_view = 'CATEGORY';
    },
    setProductForProfitEstimation(product_id) {
      if (this.$root.selectedProduct) {
        this.setDistinctProductsOnCampaign();
        var mainProductId = this.$root.selectedProduct.product.id,
          additionalProducts = this.$root.campaignData.additionalProducts,
          additionalProduct = _.first(_.filter(this.$root.campaignData.additionalProducts, function(product) {
            return product.product != mainProductId && product.product == product_id;
          })),
          self = this,
          productForEsimation = null;

        if (product_id == undefined || mainProductId == product_id || additionalProducts.length == 0 || additionalProduct == undefined) {
          productForEsimation = {
            id: this.$root.selectedProduct.product.id,
            profit: this.mainProductMinimumProfit,
            type: 'MAIN',
            selling_price: this.sellingPrice
          };
        } else {
          productForEsimation = {
            id: additionalProduct.product,
            profit: (self.$root.isDTGForced() ? additionalProduct.dtg_profit : additionalProduct.profit),
            type: 'PRODUCT',
            selling_price: additionalProduct.selling_price
          };
        }

        this.selectedProductItemForEstimation = productForEsimation.id;
        this.selectedProductForEstimation = productForEsimation;
      } else {
        this.selectedProductForEstimation = null;
      }
    },
    getProductById(id) {
      var products = _.flatten(_.pluck(this.$root.product_categories, 'category_products'));
      return _.find(products, function(p) {
        return p.product == id;
      });
    },
    getPricingByProduct(product, goal) {
      return this.$root.getPricingByProduct(product, goal);
    },
    isPhoneCase() {
      return this.$root.isPhoneCaseProduct();
    },
    minProfitItems(estimatedGoal) {
      var selectedProduct = this.selectedProductForEstimation;
      if (selectedProduct) {
        var selling_price = selectedProduct.selling_price,
          basePrice = this.getSalePriceBySelectedProductForEstimation(estimatedGoal),
          profit = parseFloat(parseFloat(selling_price) - parseFloat(basePrice)).toFixed(2);
        return profit < 0 ? 0 : profit;
      }
      return 0.00;
    },
    minOverallProfit(numItems) {
      return parseFloat(this.minProfitItems(numItems) * numItems).toFixed(2);
    },
    getSalePriceBySelectedProductForEstimation(estimatedGoal) {
      var selectedProduct = this.selectedProductForEstimation;
      if (selectedProduct) {
        var productObj = this.getProductById(selectedProduct.id),
          type = selectedProduct.type,
          basePrice = this.getPricingByProduct(productObj.products, estimatedGoal, type),
          dtgPrice = this.getPricingByProduct(productObj.products, 1, type);

        return dtgPrice < basePrice ? dtgPrice : basePrice;
      }
      return 0.00;
    },
    onProductChangedForEstimate() {
      this.setProductForProfitEstimation(this.selectedProductItemForEstimation);
    },
    setDistinctProductsOnCampaign() {
      if (this.$root.selectedProduct) {
        this.distinctProductsOnCampaign = [];
        var mainProduct = this.$root.selectedProduct.product;
        var additionalProducts = _.filter(this.$root.campaignData.additionalProducts, function(product) {
            return product.product != mainProduct.id;
          }),
          self = this;


        this.distinctProductsOnCampaign.push({ value: mainProduct.id, text: mainProduct.name });

        _.each(additionalProducts, function(product) {
          var productExists = _.find(self.distinctProductsOnCampaign, function(addedProduct) {
            return product.product == addedProduct.value;
          });

          if (productExists == null) {
            var categoryProducts = self.getProductById(product.product);

            if(categoryProducts !== undefined && categoryProducts.hasOwnProperty('products')) {
              var productObj = categoryProducts.products

              self.distinctProductsOnCampaign.push({ value: productObj.id, text: productObj.name });
            }

          }
        });
      }
    },
    isMainProductUSOnly() {
      return this.$root.isMainProductUSOnly();
    }
  },
  computed: {
    sortedColors: function() {
      var activeColors = _.filter(this.mainProductColors, function(color) {
        return color.active == 1;
      });
      return this.$root.getDesignerHelper().sortColors(activeColors);
    },
    productsFromCategory: function() {
      var category = this.activeCategory,
        products = _.filter(this.toBoundProducts, function(product) {
          return product.category == category.id;
        });

      if (this.isAPIOrder()) {
        return _.filter(products, function(product) {
          return product.products.dtg_drop_is_locked == 0;
        });
      }
      return products;
    },
    suggestedPriceToShow() {
      if (this.$root.selectedProduct)
        return this.$root.selectedProduct.product.suggested_price;
      return 0.00;
    },
    selectedProductForEstimationObj() {
      if (this.$root.product_categories.length > 0) {
        var product = this.selectedProductForEstimation;
        if (product) {
          var productObj = this.getProductById(product.id);
          return { product: productObj.products, selling_price: product.selling_price, type: product.type };
        }
      }
    },
    mainProductMinimumSinglePrice() {
      if (this.$root.selectedProduct) {
        var mainProductObj = this.getProductById(this.$root.selectedProduct.product.id).products;

        return this.getPricingByProduct(mainProductObj, 1, "MAIN");
      }
      return 0.00;
    },
    mainProductMinimumProfit() {
      if (this.$root.selectedProduct) {
        var mainProductPricing = this.mainProductMinimumSinglePrice;

        return parseFloat(parseFloat(this.sellingPrice) - parseFloat(mainProductPricing)).toFixed(2);
      }
      return 0.00;
    },
    minSingleSalePrice() {
      return this.getMinimumSalePriceByProductForEstimation(1);
    },
    min1ProfitItem() {
      return this.minOverallProfit(1);
    },
    min1OverallProfit() {
      return this.minOverallProfit(1);
    },
    min10ProfitItem() {
      return this.minProfitItems(10);
    },
    min10OverallProfit() {
      return parseFloat(this.min10ProfitItem * 10).toFixed(2);
    },
    min25ProfitItem() {
      return this.minProfitItems(25);
    },
    min25OverallProfit() {
      return parseFloat(this.min25ProfitItem * 25).toFixed(2);
    },
    min50ProfitItem() {
      return this.minProfitItems(50);
    },
    min50OverallProfit() {
      return parseFloat(this.min50ProfitItem * 50).toFixed(2);
    },
    min100ProfitItem() {
      return this.minProfitItems(100);
    },
    min100OverallProfit() {
      return parseFloat(this.min100ProfitItem * 100).toFixed(2);
    },
    min500ProfitItem() {
      return this.minProfitItems(500);
    },
    min500OverallProfit() {
      return parseFloat(this.min500ProfitItem * 500).toFixed(2);
    },
    isDTGProduct() {
      return this.$root.isDTGProduct;
    },
    campaignGoal() {
      return this.$root.campaignData.goal;
    },
    estimatedProfit() {
      if (this.$root.selectedProduct) {
        var mainProduct = this.$root.selectedProduct.product;
        var additionalProducts = _.filter(this.$root.campaignData.additionalProducts, function(product) {
            return product.product != mainProduct.id;
          }),
          profits = [],
          self = this,
          mainProductSellingPrice = this.sellingPrice,
          currentGoal = this.sliderCount,
          mainProductBasePrice = this.getPricingByProduct(this.getProductById(mainProduct.id).products, currentGoal),
          mainProductProfit = parseFloat(mainProductSellingPrice) - parseFloat(mainProductBasePrice),
          distinctProducts = [];


        profits.push((parseFloat(mainProductProfit) * parseFloat(currentGoal)).toFixed(2));

        _.each(additionalProducts, function(product) {
          var productExists = _.find(distinctProducts, function(addedProduct) {
            return product.product == addedProduct.id;
          });

          if (productExists == null) {
            var additionalProductSellingPrice = product.selling_price,
              additionalProductBasePrice = self.getPricingByProduct(self.getProductById(product.product).products, currentGoal),
              additionalProductProfit = parseFloat(additionalProductSellingPrice) - parseFloat(additionalProductBasePrice);
            profits.push((parseFloat(additionalProductProfit) * parseFloat(currentGoal)).toFixed(2));
            distinctProducts.push(product);
          }
        });

        var maxProfit = _.max(profits);

        if (profits.length > 1)
          return '$' + _.min(profits) + ' - $' + maxProfit;
        else
          return '$' + _.min(profits);
      }
      return '$0';
    },
    selectedProductPath() {
      if (this.isSublimationProduct()) {
        if (this.$root.designerItems[this.$root.currentSide].length > 0) {
          this.showLoading = false;
          return this.$root.preview[this.$root.currentSide].large;
        } else
          return '';
      } else {
        let path = _.get(this.$root.selectedProduct, `image.${this.$root.currentSide}.original`);

        return path ? `${this.$root.getDesignerHelper().imagePath}${path}` : null;
      }
    },
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/details_tab/index.js